export default "/assets/images/the-mama-to-be-crop.webp?da2a004b47cf4bdd26b9ebe5d12165d7";